/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import { getPolicySingle, resetQuotes } from '../../../actions'

/**
 * Import
 * - Page component
 */
import Summary from '../../../components/pages/Quote/Summary/Summary'

const mapStateToProps = (state: RootState) => {
    return {
        quote: state.quote,
        policy: state.policiesSingle,
    }
}

export default connect(
    mapStateToProps,
    {
        getPolicySingle: getPolicySingle,
        resetQuotes: resetQuotes,
    }
)(Summary)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Summary.tsx